<template>
  <div class="sxTaskItem">
    <Header title="任务填报"></Header>
    <NOdata
      v-if="(this.list && this.list.length == 0) || this.list == '[]'"
      title="未查询到任务填报"
    ></NOdata>
    <div v-else class="list">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="content">
          <div class="head">
            <p>{{ item.bt }}</p>
            <p>指导老师评价情况</p>
          </div>
          <van-field
            :class="
              item.sftg == '1' ? 'pass' : item.sftg == '0' ? 'reback' : ''
            "
            v-model="item.xspy"
            rows="2"
            autosize
            :label="'状态：' + item.zdjspj"
            type="textarea"
            maxlength="500"
            placeholder="填报内容"
            show-word-limit
            :readonly="item.sftg == '1' ? 'readonly' : false"
          />
        </div>
        <div class="operate" v-if="item.sftg == 0 || item.sftg == ''">
          <span class="ckxsClass" @click="save(item)">提交</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      message: "",
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async save(item) {
      const res = await Api.sxrwxspjsave({
        sxrwpjid: item.sxrwpjid,
        sxrwxspjid: item.sxrwxspjid,
        xspy: item.xspy
      });
      if (res.code == "1") {
        this.$toast.success("提交成功");
        setTimeout(() => {
          this.$router.replace({
            path: "/sxTask/index"
          });
        }, 1500);
      } else {
        return;
      }
    },
    async getList() {
      const res = await Api.getsxrwxspjlist({
        rwfbid: this.$route.query.list.rwfbid
      });
      this.list = res.data;
    }
  }
};
</script>
<style lang="less" scoped>
.sxTaskItem .list {
  padding: 0 20px 0 20px;
  .list-item {
    background: #f8f8f8;
    border-radius: 5px;
    margin-bottom: 20px;
    padding: 10px;
    .content {
      .head {
        display: flex;
        justify-content: space-between;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          margin-bottom: 2%;
        }
      }
    }
    .operate {
      border-top: 1px solid #dee1e9;
      height: 20px;
      line-height: 20px;
      display: flex;
      padding-top: 10px;
      span {
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #212f6e;
        letter-spacing: 0;
        text-align: center;
        cursor: pointer;
        font-weight: bold;
        // &:first-child {
        //   border-right: 1px solid #dee1e9;
        // }
      }
    }
  }
}
</style>
<style lang="less">
.sxTaskItem {
  .van-cell {
    border: 1px solid #e5e5e5;
    flex-direction: row-reverse;
    line-height: 24px;
    padding: 0;
    margin-bottom: 10px;
  }
  .van-field__label {
    border-left: 1px solid #e5e5e5;
    padding: 10px 5px;
    font-size: 14px;
    line-height: 16px;
    margin-right: 0;
  }
  .van-field__value {
    padding: 5px;
  }

  .pass .van-field__label {
    background-color: rgba(18, 221, 214, 0.1);
    span {
      color: #12ddd6 !important;
    }
  }
  .reback .van-field__label {
    background-color: rgba(248, 105, 105, 0.1);
    span {
      color: #f86969 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxTask/item.vue